import { type } from "arktype";

export const AuditEvent = type({
  id: "string",
  practiceId: "string",
  actorId: "string",
  actorKind: "'user' | 'agent' | 'system'",
  action: "string",
  resource: "string",
  "grantId?": "string | null",
  at: "string",
  "detail?": "unknown",
});
export type AuditEvent = typeof AuditEvent.infer;
